import {
    BasicResponsiveImage,
    Link,
    ProgressiveImage,
    StandardTile,
    StandardTileContents,
    StandardTileDescription,
    StandardTileImage,
    StandardTileName,
    tokens,
} from '@vp/swan';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import type { BlogPost } from '../../../../utils/blog';

interface BlogPostTileProp {
    blogPost: BlogPost;
}

const BlogPostTile = ({ blogPost }: BlogPostTileProp) => {
    return (
        <StandardTile skin="standard" pb="6">
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'NewsArticle',
                        headline: blogPost.title,
                        image: [blogPost.thumbnail?.imageUrl],
                    }),
                }}
            />
            <StandardTileImage overflow="hidden" style={{ position: 'relative' }}>
                <ProgressiveImage
                    src={blogPost.thumbnail?.imageUrl}
                    trigger="inView"
                    intersectionOptions={{ threshold: 0 }}
                >
                    {(image, isLoading) => (
                        <BasicResponsiveImage
                            aspectRatio={0.5625}
                            src={image.src}
                            alt={blogPost.thumbnail?.altText}
                            style={{
                                filter: isLoading ? 'blur(20px)' : 'none',
                                transition: 'filter 0.6s ease-out',
                            }}
                        />
                    )}
                </ProgressiveImage>
            </StandardTileImage>
            <StandardTileContents>
                <StandardTileName
                    fontSkin="title-subsection"
                    style={{
                        marginBottom: tokens.SwanSemSpace3,
                        textWrap: 'balance',
                    }}
                >
                    <Link
                        href={blogPost.url}
                        covering
                        target="_blank"
                        rel="noreferrer"
                        skin="unstyled"
                        ref={useTrackNavigationClicked(
                            'Logo Ideas',
                            'LogoTips',
                            blogPost.url,
                            blogPost.slug,
                        )}
                    >
                        {blogPost.title}
                    </Link>
                </StandardTileName>
                {blogPost.description && (
                    <StandardTileDescription>{blogPost.description}</StandardTileDescription>
                )}
            </StandardTileContents>
        </StandardTile>
    );
};

export default BlogPostTile;
